/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendSalaryDto } from '../../models/backend-salary-dto';
import { BackendSalaryRequestDto } from '../../models/backend-salary-request-dto';

export interface OpexesSalaryCreate$XWwwFormUrlencoded$Params {
  body: BackendSalaryRequestDto;
}

export function opexesSalaryCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: OpexesSalaryCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendSalaryDto>> {
  const rb = new RequestBuilder(rootUrl, opexesSalaryCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendSalaryDto>;
    }),
  );
}

opexesSalaryCreate$XWwwFormUrlencoded.PATH = '/api/opexes/salary/';
